import { dateFormat } from "../../const/date";
import sanitizeHtml from "sanitize-html";

type BlogData = {
  data: {
    category: Array<string>;
    title: Array<string>;
    link: Array<string>;
    description: Array<string>;
    pubDate: Array<string>;
  }[];
};

const Blog = ({ data }: { data: BlogData[] | any[] }) => {
  const blog = ParseData({ data });

  const getTranslated = (key: string) => {
    const text = key || ""; //data json에서 호출
    const sanitizedText = sanitizeHtml(text, {
      allowedTags: ["br", "em", "span"], //허용할 태그 지정
    });
    return { __html: sanitizedText };
  };
  return (
    <div
      id="blog"
      className="relative w-full h-full max-w-[1400px] px-2 mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div id="title" className="relative w-full h-fit mb-5 xl:mb-10 gmedium">
        <h3 className="font-normal">
          <span className="text-secondary">청소의 달인</span>{" "}
          <span className="text-[#00bf19]">BLOG</span>&nbsp;작업사례
        </h3>
        <div className="relative w-full h-fit mx-auto xl:flex justify-start items-center gap-5 xl:gap-14 my-5">
          <p className="text-lg lg:text-xl mb-5 lg:mb-0">
            청소의&nbsp;달인의&nbsp;생생한&nbsp;작업현장들
            <br className="hidden lg:inline-block" />
            어떤식으로 작업이 이루어지는지 블로그를&nbsp;통해
            확인&nbsp;해보세요!
          </p>
          <button
            type="button"
            className=" relative w-full lg:w-fit h-fit"
            onClick={() => window.open("https://blog.naver.com/wnsl5107")}
          >
            <img
              src="images/blogBtn.png"
              alt="blog"
              width={383}
              height={98}
              className=" !relative w-auto h-full max-h-12 xl:max-h-16  ml-auto lg:mx-0"
            />
          </button>
        </div>
      </div>
      <div className=" relative w-full h-full flex flex-wrap-reverse lg:flex-nowrap lg:grid grid-cols-3">
        <div className=" relative w-full h-full">
          <div className="lg:absolute -left-24 -right-24 bottom-0 lg:w-[650px] h-full">
            <img
              src="/images/bannerIcon1.png"
              alt="하수구막힘제로 블로그"
              className=" relative lg:w-[650px] h-auto object-contain scale-x-[-1]"
            />
          </div>
        </div>
        <div className="col-span-2 relative w-full h-fit grid grid-cols-2 lg:grid-rows-3 gap-3 lg:gap-5 min-h-80">
          {blog.map((v, i) => (
            <div
              key={i}
              onClick={() => window.open(v.link[0])}
              className={
                i > 7
                  ? "hidden lg:block relative w-full h-full"
                  : "relative w-full h-full"
              }
            >
              <div className="relative w-full h-full grid bg-white p-2 md:p-3 rounded-3xl text-left border cursor-pointer transition-all duration-300 overflow-hidden">
                <p
                  className={`relative w-full whitespace-nowrap overflow-hidden overflow-ellipsis lg:text-lg h-fit mb-1 lg:mb-2`}
                >
                  {v.title[0]}
                </p>
                <small
                  className={`relative w-full whitespace-nowrap md:whitespace-normal overflow-hidden overflow-ellipsis h-fit md:h-9 my-2 lg:my-0 break-words md:line-clamp-2 text-sm opacity-60`}
                  dangerouslySetInnerHTML={getTranslated(v.description[0])}
                ></small>
                <div className="md:pt-2 lg:mt-3 3xl:mt-4 lg:flex justify-between items-end">
                  <small className="hidden xl:block opacity-40 lg:text-sm">
                    {dateFormat(v.pubDate[0])}
                  </small>
                  <small className="text-main lg:text-sm">
                    {v.category[0]}
                  </small>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;

const parseString = require("xml2js").parseString;

const ParseData = ({ data }: { data: any[] }) => {
  const dataArr: {
    title: any;
    link: any;
    description: any;
    pubDate: any;
    category: any;
  }[] = [];

  parseString(data, (err: any, result: any) => {
    if (err) {
      console.error("XML 파싱 에러:", err);
      return;
    }

    const items = result?.rss?.channel?.[0]?.item;
    if (Array.isArray(items)) {
      items.slice(0, 6).forEach((v: any) => {
        dataArr.push({
          title: v.title,
          link: v.link,
          description: v.description,
          pubDate: v.pubDate,
          category: v.category,
        });
      });
    } else {
      console.warn("item 배열이 없습니다.");
    }
  });

  return dataArr;
};
